import { styled } from "linaria/react";
import { TDirection } from "@lib/utils";

export const ChatWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #fff;
  overflow: hidden;
`;

export const Map3DContainer = styled.div`
  scale: 0.95;
  height: 550px !important;
`;

export const MapIcon = styled.button`
  position: absolute;
  top: 20px;
  left: 185px;
  width: 40px;
  height: 40px;
  z-index: 2;
  cursor: pointer;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 0;
  svg {
    width: 30px;
    height: 30px;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const PinnacleIcon = styled.button`
  position: absolute;
  top: 10px;
  left: 180px;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  z-index: 2;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  img {
    max-width: 100%;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;
export const MapWrap = styled.div`
  position: relative;
`;
export const ChatWrapContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  max-height: 100%;
  flex-grow: 1;
  min-height: 0;
  overflow: hidden;
`;
export const ChatHeader = styled.div``;
export const ChatModuleTitle = styled.div`
  text-align: center;
  margin-top: 10px;
`;
export const ChatModuleSubtitle = styled.div`
  text-align: center;
  color: #99abb4;
  margin-top: 10px;
`;
export const ChatContainer = styled.div<{ recipientView?: boolean }>`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 5px;
  padding-top: ${(props) => (props.recipientView ? "45px" : "0")};
  padding-bottom: 80px;
  flex: 1;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
`;
export const RecipientChatHeader = styled.div<{ status: "closed" | "waiting" | "assigned" }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  z-index: 1;
  background-color: ${(props) =>
    props.status === "closed" ? "#9e9e9e" : props.status === "waiting" ? "#ffc107" : "#4caf50"};
  color: ${(props) => (props.status === "closed" ? "#e0e0e0" : props.status === "waiting" ? "#333" : "#fff")};
`;

export const LocationIndicator = styled.span<{ active: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;
export const MessageNote = styled.div`
  padding: 5px;
  font-size: 14px;
  color: #555;
  text-align: left;
  cursor: pointer;
`;
export const ChatNote = styled.div<{ emphasized?: boolean }>`
  align-self: flex-end;
  padding: 5px;
  font-size: 12px;
  color: ${(props) => (props.emphasized ? "#555" : "#bbb")};
  font-style: ${(props) => (props.emphasized ? "italic" : "normal")};
  margin-bottom: ${(props) => (props.emphasized ? "0px" : "10px")};
`;
export const ChatAuthor = styled.div<{
  direction: TDirection;
}>`
  align-self: ${(props) =>
    props.direction === "outbound" ? "flex-end" : props.direction === "note" ? "center" : "flex-start"};
  padding: 5px;
  font-size: 12px;
`;
export const ChatStatus = styled.div<{
  direction: TDirection;
}>`
  align-self: ${(props) =>
    props.direction === "outbound" ? "flex-end" : props.direction === "note" ? "center" : "flex-start"};
  padding: 5px;
  font-size: 10px;
  color: #111;
`;

export const ChatTextWrap = styled.div<{
  direction: TDirection;
  hide?: boolean;
}>`
  align-self: ${(props) =>
    props.direction === "outbound" ? "flex-end" : props.direction === "note" ? "center" : "flex-start"};
  margin-bottom: 10px;
  display: ${(props) => (props.hide ? "none" : "flex")};
  flex-direction: column;
  word-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
`;
export const ChatModuleWrap = styled.div<{
  direction: TDirection;
}>`
  align-self: ${(props) =>
    props.direction === "outbound" ? "flex-end" : props.direction === "note" ? "center" : "flex-start"};
  margin-bottom: 10px;
`;
export const ChatModule = styled.div<{
  direction: TDirection;
  active: boolean;
}>`
  cursor: ${(props) => (props.active ? "pointer" : "auto")};
  border-radius: 5px;
  padding: 12px;
  background-color: ${(props) => (props.direction === "outbound" ? "#abe0f5" : "#eee")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  svg {
    width: 50px;
    height: 50px;
  }
`;
export const ChatText = styled.div<{
  direction: "outbound" | "inbound";
}>`
  border-radius: 12px;
  padding: 12px;
  margin: 3px;
  white-space: pre-wrap;
  background-color: ${(props) => (props.direction === "outbound" ? "#abe0f5" : "#eee")};
  word-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  transition: background-color 1000ms linear;

  &.transcript-item strong::first-letter {
    text-transform: uppercase;
  }

  &.transcript-identity-responder {
    background-color: #abe0f5;
  }

  &.transcript-identity-0 {
    background-color: #abe0f5;
  }

  &.transcript-identity-1 {
    background-color: #eee;
  }

  &.transcript-identity-2 {
    background-color: #ffc107;
  }
  &.transcript-identity-3 {
    background-color: #0acc95;
  }
  &.transcript-identity--1 {
    background-color: #0acc95;
  }

  &.highlight {
    background-color: #d6d8d9;
  }
`;
export const ChatInputContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  flex-shrink: 0;
  padding: 8px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  background-color: #eee;
  z-index: 1;
  @supports (padding: env(safe-area-inset-bottom)) {
    padding-bottom: max(8px, env(safe-area-inset-bottom));
  }
  textarea {
    &:active,
    &:focus-within {
      border: 1px solid #7b7c7d;
    }
    &:focus-visible {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }
  }
  [class*="rc-dropdown-trigger"] {
    display: flex !important;
    align-self: stretch;
  }
`;

export const ChatInput = styled.textarea<{ recipient: boolean }>`
  width: ${(props) => (props.recipient ? "calc(100%)" : "calc(100% - 55px)")};
  margin-right: ${(props) => (props.recipient ? "5px" : 0)};
  border-radius: 4px;
  border-color: #c6c8ca;
  font-size: 16px;
  line-height: 1.5;
  min-height: 44px;
  padding: 8px;

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const ChatButton = styled.button`
  width: 100px;
  background: #abe0f5;
  border: 0;
  cursor: pointer !important;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const ChatMenu = styled.div`
  width: 40px;
  border: 0;
  cursor: pointer;
`;

export const TemplateMenu = styled.div`
  width: 40px;
  border: 0;
  cursor: pointer;
`;

export const ChatToggle = styled.button`
  cursor: pointer;
  height: 100%;
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  svg {
    width: 30px;
    height: 30px;
    margin-top: 5px;
    margin-left: 5px;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const TemplateActionList = styled.div<{ show: boolean }>`
  display: ${(props) => (props.show ? "flex" : "none")};
  position: absolute;
  flex-direction: column;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #eee;
  width: 150px;
  background: white;
  bottom: 60px;
  right: 10px;
  max-height: 250px;
  overflow: auto;
  > div + div {
    margin-top: 5px;
    font-size: 16px;
  }
`;

export const ChatActionList = styled.div<{ show: boolean }>`
  display: ${(props) => (props.show ? "flex" : "none")};
  position: absolute;
  flex-direction: column;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #eee;
  width: 250px;
  width: 150px;
  background: white;
  bottom: 60px;
  left: 10px;
  max-height: 250px;
  overflow: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  > div + div {
    margin-top: 5px;
    font-size: 16px;
  }
`;
export const ChatMenuItem = styled.div`
  cursor: pointer;
  color: black;
  padding: 0.25rem 0.5rem;
  height: 25px;
  vertical-align: middle;
  display: inline-block;
  line-height: 25px;
  :hover {
    background: #e9ecef;
  }
`;

export const TranslateWrap = styled.div``;
export const TranslatedText = styled.div`
  background: white;
  padding: 8px;
`;

export const SendMessageOptionItem = styled.div<{ active?: boolean }>`
  cursor: pointer;
  color: black;
  padding: 4px 8px;
  background-color: ${(props) => !props.active ? "transparent" : "#b7f1e0"};
`;

export const SendMessageOptionsTrigger = styled.button`
  padding: 8px;
  background: #abe0f5;
  border: 0;
  border-left: 1px solid #c6c8ca;
  cursor: pointer !important;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;
